import React, {FunctionComponent, useEffect} from "react";
import {Autocomplete, FormControl, TextField} from "@mui/material";
import {FilterableMetadata} from "../../../entity/FilterableMetadata";
import {StringUtils} from "../../../book/StringUtils";
import {ProductPropertyData, usePostApiV1ProductPropertyFilterMutation} from "../../../api/GovernanceToolApi";
import {useTranslation} from "react-i18next";

export const ProductPropertyFilter: FunctionComponent<FilterProductPropertyProps> = props => {
    const {t} = useTranslation();
    const [searchProductPropertyFilter, {
        data: productPropertyFilter,
        isLoading: isProductPropertyFilterLoading,
        error: productPropertyFilterError
    }] = usePostApiV1ProductPropertyFilterMutation();

    useEffect(() => {
        searchProductPropertyFilter({searchProductPropertyFiltersRequest: {category: props.category}})
    }, [props.category]);

    const productPropertyFilters = (productPropertyFilter?.payload?.productPropertyFilters ?? []);
    const filterableMetadata = productPropertyFilters
        .filter((productProperty, index) => {
            return index === productPropertyFilters.findIndex(obj => {
                return obj.value === productProperty.value;
            });
        })
        .map(m => ({...m} as FilterableMetadata));

    return <FormControl
        fullWidth
        key={`form-control-${props.category}`}
        variant="outlined">
        <Autocomplete
            fullWidth
            disablePortal
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            noOptionsText={t("No option")}
            disabled={isProductPropertyFilterLoading || Boolean(productPropertyFilterError)}
            options={filterableMetadata}
            getOptionLabel={option => {
                return option?.inputValue ?? option?.value ?? '';
            }}
            value={props.value as FilterableMetadata}
            onChange={(e, newValue) => props.onChange(newValue)}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) =>
                <TextField {...params}
                           label={StringUtils.capitalizeFirstLetter(props.category)}
                           value={props.value?.value}
                           disabled={isProductPropertyFilterLoading}
                           error={Boolean(productPropertyFilterError)}/>}/>
    </FormControl>;
}

export interface FilterProductPropertyProps {
    category: string;
    value: ProductPropertyData | null;
    onChange: (newValue: ProductPropertyData | null) => void
}